import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { RegionLocationLinkContainerModel } from '../../../../../../../models/aggregates/erp/delivery/region/region-location-link-container.model';



@Injectable({
  providedIn: 'root'
})
export class RegionLocationLinkService extends BaseApiTemplateService<RegionLocationLinkContainerModel> {
    // https://api-test.akaun.com/core2/tnt/dm/del/region-comp-branch-location-links
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/region-comp-branch-location-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/region-comp-branch-location-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/region-comp-branch-location-links';
    this.httpClient = http;
  }
}
